import styled, { css } from 'styled-components'
import { colors } from 'client/styles'

const pillStyle = css`
  color: ${props => (props.color ? props.color : colors.white)};
  background-color: ${props => (props.background ? props.background : colors.magenta)};
  border-radius: 3px;
  padding-block: 4px;
  padding-inline: 6px;
`

const primeStyle = css`
  background-color: ${colors.purple2};
  svg {
    display: inline-block;
    fill: ${colors.white};
    margin-inline-end: 5px;
  }
  p {
    background-color: ${colors.purple2};
  }
`

export const TagBase = styled.div`
  align-items: center;
  display: inline-flex;
  font-weight: ${props => props.bold && '700'};

  svg {
    display: inline-block;
    fill: ${props => colors[props.background]};
    margin-inline-end: 5px;
  }

  ${props =>
    props.withIcon
      ? css`
          p {
            ${pillStyle}
          }
        `
      : css`
          ${pillStyle}
        `}

  ${props => props.prime && primeStyle}
`
